import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=bd066a4a&scoped=true&"
import script from "./Headers.vue?vue&type=script&lang=js&"
export * from "./Headers.vue?vue&type=script&lang=js&"
import style0 from "./Headers.vue?vue&type=style&index=0&id=bd066a4a&prod&scoped=true&lang=scss&"
import style1 from "./Headers.vue?vue&type=style&index=1&id=bd066a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd066a4a",
  null
  
)

export default component.exports